<div *ngIf="toast.visible" [ngClass]="getToastClass()" class="custom-toast">
  <div class="toast-content">
    <span>{{ toast.message }}</span>
    <button class="close-btn" (click)="hideToast()">Close</button>
  </div>
</div>